module.exports = __webpack_public_path__ + "media/metronic/_theme/media/misc/bg-1-8aaadee60c455a2260b18d1ea34559d2.jpg";